import React from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';

import UnpublishedDataContainer from 'components/Classification/UnpublishedData';
import { SpendTypeEnum } from 'components/Classification';

import { CONFIG, ROOT_ROUTE } from './routes';

export const Classification = () => {
  return (
    <Switch>
      <Route
        path={`${ROOT_ROUTE}/:spendType(${CONFIG.map((tab) => tab.name).join(
          '|'
        )})`}
        exact
        render={({ match }) => (
          <UnpublishedDataContainer
            spendType={match.params.spendType as SpendTypeEnum}
          />
        )}
      />
      <Redirect to={CONFIG[0].path} />
    </Switch>
  );
};

export default Classification;
